import { defineStore } from 'pinia';
import { shouldThrottle } from '@/util/rateLimit.js';
import posthog from '@/composables/usePostHog.js';
import apiClient from '@/util/apiClient';

export const useUspsStore = defineStore('uspsStore', {
	state: () => ({}),
	actions: {
		async standardize(addressInput) {
			if (shouldThrottle('usps_standardize', 100)) {
				posthog.capture('throttled_action', { action: 'usps_standardize' });
				return { success: false, message: 'Request throttled' };
			}

			try {
				const { data } = await apiClient.post('/addresses/standardize', addressInput);
				return {
					success: true,
					status: data?.status,
					message: data?.message,
					original: data?.original,
					standardized: data?.standardized,
					confirmationToken: data?.confirmationToken || null
				};
			} catch (e) {
				return {
					success: false,
					status: 'ERROR',
					message: e.response?.data?.message || 'Address standardization failed'
				};
			}
		}
	}
});
